import * as yup from 'yup';

import { getTranslatedMessage } from '@/i18n/utils';

import { ForeignIndiciaCountryDetail } from '@/utils/user';

import { buildForeignNonTaxResidenciesValidator } from '../ForeignNonTaxResidencySection/schema';
import { buildForeignTaxResidenciesValidator } from '../ForeignTaxResidencySection/schema';
import {
  buildIndiciaReasonCodeValidator,
  buildIndiciaReasonOtherValidator,
} from '../OtherCountriesForeignIndiciaSection/schema';
import { OtherCountriesTaxFormValues } from '../utils/types';

export function isOtherCountriesTaxFormValid(
  values: OtherCountriesTaxFormValues,
  foreignIndiciaCountries: ForeignIndiciaCountryDetail[] = [],
): boolean {
  return getOtherCountriesTaxValidationSchema(
    foreignIndiciaCountries,
  ).isValidSync(values);
}

export function getOtherCountriesTaxValidationSchema(
  foreignIndiciaCountries: ForeignIndiciaCountryDetail[] = [],
) {
  return yup.object({
    hasForeignIndicia: yup
      .boolean()
      .required(getTranslatedMessage('taxInfoDrawer.question2.required')),
    isForeignTaxResident: yup
      .boolean()
      .required(getTranslatedMessage('taxInfoDrawer.question2.required')),
    indiciaReasonCode: buildIndiciaReasonCodeValidator(foreignIndiciaCountries),
    indiciaReasonOther: buildIndiciaReasonOtherValidator(
      foreignIndiciaCountries,
    ),
    foreignTaxResidencies: buildForeignTaxResidenciesValidator(),
    foreignNonTaxResidencies: buildForeignNonTaxResidenciesValidator(),
  });
}
